/**
 * Role utility functions for checking user permissions.
 */

export const getUserRole = () => {
    return localStorage.getItem('user_role');
};

export const isAdmin = () => {
    return getUserRole() === 'Admin';
};

export const isSalesPerson = () => {
    return getUserRole() === 'Sales_Person';
};

export const isSalesCoordinator = () => {
    return getUserRole() === 'Sales_Coordinator';
};

export const isITAdmin = () => {
    return getUserRole() === 'IT_Admin';
};

export const isManagement = () => {
    return getUserRole() === 'Management';
};

export const canSeeMargin = () => {
    return isAdmin();
};

export const canViewAllSalespersons = () => {
    return isAdmin() || isManagement();
};

export const canManageUsers = () => {
    return isITAdmin() || isAdmin();
};
